import React from "react";
import "./TeamCenterIntegrationAutocad.css";
import Teacher from "../../../../../assets/images/plmimplementationimage/Teacher-amico.png";
import Letsgetintouch from "../../../BusinessProcessAndChangeManagement/Letsgetintouch";
import TIAutocadOverview from "./TIAutocadOverview";
import FloatingContactUs from "../../../../floting_contact/FloatingContactUs";
import { NavLink } from "react-router-dom";

const TeamCenterIntegrationAutocad = () => {
  return (
    
    <section className="TINX-management">
      <div className="banner">
        <div className="banner-content">
          <img src={Teacher} alt="teacher" className="banner-image" />
          <div className="banner-text">
            <h4 className="TINX-process-h4">
              Teamcenter Integration for AutoCAD{" "}
            </h4>
          </div>
        </div>
      </div>

      <div>
         <FloatingContactUs />
      </div>


      <div className="container">
        <TIAutocadOverview />
        <div className="benefits">
          <h4 className="TINX-page-heading">Unlock the Power :</h4>
          <h5 className="TINX-subheading">
            Discover the Transformative Benefits of NexTech!
          </h5>
          <ul className="custom-bullets">
            <li>
              Seamlessly integrate AutoCAD into your managed mode environment,
              optimizing your design processes.
            </li>
            <li>
              Ensure that all teams work with the latest design information,
              reducing search time and minimizing change orders.
            </li>
            <li>
              Facilitate collaboration across locations and supply chains,
              speeding up the product development process.
            </li>
            <li>
              Integrate AutoCAD files with your technical data, providing a
              single source of information for the entire
              design-through-manufacturing process.
            </li>
            <li>
              Minimize the time spent by technical staff searching for correct
              revisions of CAD data.
            </li>
            <li>Maintain consistent work processes across all data formats.</li>
            <li>
              Accelerate product change and approval processes, leading to a
              reduced time-to-market.
            </li>
            <li>
              Manage CAD files and all technical data in a unified system,
              supporting the complete design-through-manufacturing process.
            </li>
          </ul>
        </div>

        <div className="solutions container">
  <div className="solutions-content">
    <div className="row">
      {/* Left Section: Detailed TINX Solutions */}
      <div className="col-md-6 col-12">
        <h4 className="TINX-page-heading">Our Solutions</h4>

        <h5>2TIER & 4TIER Integration:</h5>
        <p className="plmimplementationparagraph">
          Connect AutoCAD with Teamcenter for comprehensive data management.
        </p>

        <h5>Title Block Synchronization:</h5>
        <p className="plmimplementationparagraph">
          Synchronize title blocks using Teamcenter database attributes.
        </p>

        <h5>Mechanical Properties Synchronization:</h5>
        <p className="plmimplementationparagraph">
          Ensure consistency in mechanical properties across systems.
        </p>

        <h5>Bidirectional Attribute Mapping:</h5>
        <p className="plmimplementationparagraph">
          Map attributes between AutoCAD and Teamcenter in both directions.
        </p>
      </div>

      {/* Right Section: Quick Links */}
      <div className="col-md-6 col-12">
        <div className="quick-links">
          <h4>Quick Links</h4>
          <ul>
            <li>
              <NavLink to={"/teamcenter/mcad-integration/solidwork-integration"}>
                Teamcenter Integration for SolidWorks
              </NavLink>
            </li>
            <li>
              <NavLink to={"/teamcenter/mcad-integration/pro-engineer-integration"}>
                Teamcenter Integration for Creo Pro/ENGINEER
              </NavLink>
            </li>
            <li>
              <NavLink to={"/teamcenter/mcad-integration/catia-integration"}>
                Teamcenter Integration for CATIA
              </NavLink>
            </li>
            <li>
            <NavLink to={"/teamcenter/mcad-integration/nx-integration"}>
                         Teamcenter Integration for NX
            </NavLink>
            </li>
            <li>
              <NavLink to={"/teamcenter/solidedge-integration"}>
                Teamcenter Integration for Solid Edge
              </NavLink>
            </li>
            <li>
              <NavLink to={"/teamcenter/mcad-integration"}>
                MCAD Integration
              </NavLink>
            </li>
            <li>
              <NavLink to={"/teamcenter/ecad-integration"}>
                ECAD Integration
              </NavLink>
            </li>
            <li>
              <NavLink to={"/teamcenter/business-process-management"}>
                Business Process and Change Management
              </NavLink>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</div>


        <div className="solutions">
          
          <h4 className="TINX-page-heading">Performance Tuning</h4>
          <h5 className="plm-h5">System Optimization: </h5>
          <p className="plmimplementationparagraph">
            Configure OS, hardware, and server/client components for optimal
            performance in AutoCAD managed mode.
          </p>
        </div>

        <div className="best-practices">
          <h4 className="TINX-page-heading">Best Practices</h4>

          <h5 className="plm-h5">Managed Mode Activities:</h5>
          <p className="plmimplementationparagraph">
            Implement best practices for managing AutoCAD data, including
            handling drawings and XREFs.
          </p>

          <h5 className="plm-h5">Neutral File Creation: </h5>
          <p className="plmimplementationparagraph">
            Generate neutral files (e.g., PDF, TIFF) from .DWG and DXF formats
            within Teamcenter.
          </p>

          <h5 className="plm-h5">Title Block Management:</h5>
          <p className="plmimplementationparagraph">
            Update, replace, and manage title blocks, including relationships
            and auxiliary files.
          </p>

          <h5 className="plm-h5">JT Conversion:</h5>
          <p className="plmimplementationparagraph">
            Convert AutoCAD data into JT format for interoperability.
          </p>

          <h5 className="plm-h5">Mechanical Properties Management:</h5>
          <p className="plmimplementationparagraph">
            Store and manage mechanical properties effectively.
          </p>
        </div>

        <div className="migration">
          <h4 className="TINX-page-heading">Legacy Data Migration:</h4>

          <h5 className="migration-heading">Migration Methodology:</h5>
          <p className="plmimplementationparagraph">
            Utilize a proven methodology for migrating AutoCAD legacy data to
            Teamcenter, including:
          </p>
          <ul>
            <li>
              <h5 className="plm-h5">Data Assessment & Analysis:</h5>
              <p className="plmimplementationparagraph">
                Evaluate and prepare legacy data for migration.{" "}
              </p>
            </li>
            <li>
              <h5 className="plm-h5">Data Cleanup:</h5>
              <p className="plmimplementationparagraph">
              Clean up data to ensure accuracy and consistency. {" "}
              </p>
            </li>
            <li>
              <h5 className="plm-h5">Data Migration & Testing:</h5>
              <p className="plmimplementationparagraph">
              Execute the migration process and test for correctness. {" "}
              </p>
            </li>
            <li>
              <h5 className="plm-h5">Production Rollout:</h5>
              <p className="plmimplementationparagraph">
              Implement the migrated data in the production environment. {" "}
              </p>
            </li>
          </ul>
      
        </div>
      </div>
      <Letsgetintouch />
    </section>
  );
};

export default TeamCenterIntegrationAutocad;
